'use client';

import Link from 'next/link';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';
import { trackFathomEvent } from '@/lib/fathom/trackFathomEvent';
import { AllFathomEventNames } from '@/lib/fathom/fathom-events';

interface AnimatedLink {
  href?: string;
  linkText: string;
  className?: string;
  hrefTarget?: ComponentPropsWithoutRef<'a'>['target'];
  fathomEvent?: AllFathomEventNames;
}

export function AnimatedLink({ href, linkText, className, hrefTarget = '_self', fathomEvent }: AnimatedLink) {
  const linkClasses = clsx('group flex w-fit items-center justify-center gap-2', className);

  const handleClick = () => {
    if (fathomEvent) {
      trackFathomEvent(fathomEvent);
    }
  };

  return href ? (
    <Link className={linkClasses} href={href} target={hrefTarget} onClick={handleClick}>
      <span className="underline-text-transition-blue">{linkText}</span>
      <ArrowRightIcon className="mb-0.5 size-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-gradle-blue" />
    </Link>
  ) : (
    <button className={linkClasses} onClick={handleClick}>
      <span className="underline-text-transition-blue">{linkText}</span>
      <ArrowRightIcon className="mb-0.5 size-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-gradle-blue" />
    </button>
  );
}
